export default "__VITE_ASSET__933f43da__"